<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                    <md-autocomplete
                        autocomplete="off"
                        v-model="managerName"
                        :md-options="users"
                        @md-selected="selectUser"
                        @md-changed="getUsers"
                    >
                        <label>HQ Manager</label>
                        <template slot="md-autocomplete-item" slot-scope="{ item }">
                            <span v-text="getHqManagerString(item)"></span>
                        </template>

                        <template slot="md-autocomplete-empty" slot-scope="{ term }">
                            <p v-if="managerName.length > 3"> No users matching "{{ term }}" were found. </p>
                            <p v-else> Type at least 4 letters to start searching </p>
                        </template>
                    </md-autocomplete>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
    model: {
        prop: 'academy',
        event: 'change'
    },
    name: "OrganizationTabAcademy",
    computed: {},
    props: {
        academy: {
            type: Object,
            default() {
                return {};
            }
        },
        options: {
            type: Object,
        },
        isUpdateMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userPromise: '',
            managerName: '',
            users: []
        }
    },
    methods: {
        getUsers: debounce(function (searchTerm) {
            this.users = new Promise(resolve => {
                if (searchTerm.length > 3) {
                    resolve(
                        this.$api.usersForHQManagers({
                            data: {
                                search: searchTerm,
                            }
                        }).then(({data}) => {
                            return data;
                        })
                    );
                } else {
                    this.academy.hqManager[0] = [];
                    resolve([]);
                }
            });
        }, 650),
        selectUser(hqManager) {
            //for now its the first one, but later on we need multiple users
            this.academy.hqManager[0] = hqManager;
            this.managerName = this.getHqManagerString(hqManager)
        },
        getHqManagerString(hqManager) {
            if (!hqManager){
                return '';
            }
            let email = hqManager.email ? ' - ' + hqManager.email : '';
            return hqManager.first_name + ' ' + hqManager.last_name + email;
        }
    },
    watch: {
        academy: {
            handler: function (val) {
                if (val.hqManager && val.hqManager.length > 0) {
                    //for now its the first one, but later on we need multiple users
                    this.managerName = this.getHqManagerString(val.hqManager[0]);
                }
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>
